import { useState } from "react";
import { useSelector } from "react-redux";
import { Card, Breadcrumb } from "antd";
import { Navigate, Link } from "react-router-dom";
import { MapViewerProvider } from "src/contexts/MapViewerContext";

import MapContainer from "../MapContainer";
import BasemapContainer from "src/components/Map/BasemapContainer";
import GeocodingSearchContainer from "src/components/Map/GeocodingSearchContainer";
import ScaleContainer from "src/components/Map/ScaleContainer";
import CoordinateContainer from "src/components/Map/CoordinateContainer";
import NavigationContainer from "src/components/Map/NavigationContainer";
import ZoomToolsContainer from "src/components/Map/ZoomToolsContainer";
import GpsToolsContainer from "src/components/Map/GpsToolsContainer";

import LayerUnduhCetak from "./LayerUnduhCetak";
import PopUp from "src/components/Map/PopUp";

const gridStyle = {
  width: "25%",
  textAlign: "center",
};
const App = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const [coordinate, setCoordinate] = useState();
  if (!isLoggedIn) {
    return <Navigate to="/login?page=/unduh/rbi-cetak-50k" />;
  }
  return (
    <MapViewerProvider>
      <Card
        title={
          <Breadcrumb
            items={[
              {
                title: "Beranda",
              },
              {
                title: <Link to="/unduh">Unduh Data</Link>,
              },

              {
                title: "RBI Cetak 50K",
              },
            ]}
          />
        }
        style={{ height: "100%" }}
        styles={{
          body: {
            backgroundColor: "#f0f2f5",
            height: "95%",
            padding: "0px",
          },
        }}
      >
        <MapContainer>
          <GeocodingSearchContainer />
          <ScaleContainer />
          <CoordinateContainer />
          <BasemapContainer />
          <NavigationContainer>
            <ZoomToolsContainer />
            <GpsToolsContainer />
          </NavigationContainer>
          <LayerUnduhCetak />
        </MapContainer>
        <PopUp />
      </Card>
    </MapViewerProvider>
  );
};
export default App;
